















































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import recipesDB from '../../server/init';
import categories from '../../server/init';
import firebase from 'firebase';
import slugify from 'slugify';

@Component({})
export default class EditRecipe extends Vue {
  @Prop({ type: String, default: '' })
  public activeRecipe!: string;

  public recipeContent: null;
  private categories: Array<any> = [];
  private displayUnitLabel: boolean = true;
  private formValid: boolean = false;
  private errorBlocks: Array<any> = [];


  private data() {
    return {
      recipeContent: null,
      recipeHero: null,
      recipeHeroPath: null,
      recipeHeroUpload: 0,
      ingredients: [],
      ingredientName: null,
      ingredientAmount: null,
      ingredientSubAmount: null,
      ingredientUnits: null,
      ingredientError: null,
      recipeCategoryError: null,
      recipeTitleError: null,
      recipeHeroError: null,
      recipeDescriptionError: null,
      recipeIngredientError: null,
      recipeStepError: null,
      recipeStep: null,
      recipeSteps: [],
      slug: null,
    };
  }

  private closeSheet() {
    this.$emit('closeBottom');
  }

  private numbersOnly($event: any) {
    const charCode = ($event.which) ? $event.which : $event.keyCode;
    if (charCode === 47 || (charCode >= 48 && charCode <= 57)) {
          return true;
      } else {
        $event.preventDefault();
    }
  }

  private previewImage() {
    this.$data.recipeHeroUpload = 0;
    this.$data.recipeHeroPath = null;
    this.$data.recipeHero = (<HTMLInputElement> event.target).files[0];
  }

  private deleteImage() {
  const storage = firebase.storage();
  const imageRef = storage.ref().child(this.$data.recipeHero);
  imageRef.delete().then(function(file) {
    console.log('file deleted');
  }).catch(function(error) {
    console.log('file could not be deleted');
  })
  .then(() => {
    this.$data.recipeHeroPath = null;
    this.$data.recipeHero = null;
    this.$data.recipeHeroUpload = 0;
  });
}

private validateRecipeHero() {
  if (!this.$data.recipeHero) {
    this.$data.recipeHeroError = 'Please upload an image for your recipe.';
    this.errorBlocks.push('recipe-hero-error');
    this.formValid = false;
  } else {
    this.formValid = true;
    this.$data.recipeHeroError = null;
  }
}

private uploadImage() {
  this.$data.recipeHeroPath = null;
  this.$data.recipeHeroError = null;
  const storageRef = firebase.storage().ref(`${this.$data.recipeHero.name}`).put(this.$data.recipeHero);
  storageRef.on(`state_changed`, (snapshot) => {
    this.$data.recipeHeroUpload = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  }, (error) => {console.log(error.message); },
    () => {this.$data.recipeHeroUpload = 100;
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
        this.$data.recipeHeroPath = url;
        this.$data.recipeHero = storageRef.snapshot.ref.name;
      });

    }
  );
}

private addIngredient() {
  if (this.$data.ingredientName && (this.$data.ingredientAmount || this.$data.ingredientSubAmount) && this.$data.ingredientUnits) {
      const ingredient = {ingredient: this.$data.ingredientName, amount: this.$data.ingredientAmount, subAmount: this.$data.ingredientSubAmount, units: this.$data.ingredientUnits};
    this.$data.ingredients.push(ingredient);
    this.$data.ingredientName = null;
    this.$data.ingredientAmount = null;
    this.$data.ingredientSubAmount = null;
    this.$data.ingredientUnits = null;
    this.$data.ingredientError = null;
    this.displayUnitLabel = true;
  } else {
    this.$data.ingredientError = 'You must enter an amount, a unit and a name to add an ingredient.';
  }
  if (this.$data.ingredients.length >= 2) {
    this.$data.recipeIngredientError = null;
    this.$data.ingredientError = null;
  } else {
    this.formValid = false;
  }
}

  private deleteIngredient(ingredient: any) {
    this.$data.ingredients = this.$data.ingredients.filter((ing: any) => {
      return ing !== ingredient;
    });
  }

  private addStep() {
    if (this.$data.recipeStep) {
      this.$data.recipeSteps.push(this.$data.recipeStep);
      this.$data.recipeStep = null;
    }
    if (this.$data.recipeSteps.length >= 2) {
      this.$data.recipeStepError = null;
    }
  }

  private deleteStep(step: any) {
    this.$data.recipeSteps = this.$data.recipeSteps.filter((stp: any) => {
      return stp !== step;
    });
  }

  private scrollToTop() {
    const content = document.getElementById('add-recipe');
    if (content != null) {
    content.scrollIntoView({
      block: 'center',
    });
  }
}

private validateRecipeTitle() {
  if (!this.$data.recipeContent.title) {
    this.$data.recipeTitleError = 'Please enter a title for your recipe.';
    this.errorBlocks.push('recipe-title-error');
    this.formValid = false;
  } else {
    this.formValid = true;
    this.$data.recipeTitleError = null;
  }
}

// TODO Add Validation for file upload

private validateRecipeDescription() {
  if (!this.$data.recipeContent.description) {
    this.$data.recipeDescriptionError = 'Please enter a Description for your recipe.';
    this.errorBlocks.push('recipe-description-error');
    this.formValid = false;
  } else {
    this.formValid = true;
    this.$data.recipeDescriptionError = null;
  }
}

private validateIngredients() {
  if (this.$data.ingredients.length < 2) {
    this.$data.recipeIngredientError = 'Please add 2 or more ingredients.';
    this.errorBlocks.push('recipe-ingredient-error');
    this.formValid = false;
  } else {
    this.formValid = true;
    this.$data.recipeIngredientError = null;
  }
}

private validateSteps() {
  if (this.$data.recipeSteps.length < 2) {
    this.$data.recipeStepError = 'Please add 2 or more steps.';
    this.errorBlocks.push('recipe-step-error');
    this.formValid = false;
  } else {
    this.formValid = true;
    this.$data.recipeStepError = null;
  }
}

private validateFormFields() {
  this.validateRecipeTitle();
  this.validateRecipeDescription();
  this.validateIngredients();
  this.validateSteps();
  this.validateRecipeHero();
}

private scrollToError() {
  // check for errors
  if (this.errorBlocks.length > 0) {
    for (let i = 0; i < this.errorBlocks.length; i++) {
      const errorTarget = document.getElementById(this.errorBlocks[i]);
      if (errorTarget) {
        errorTarget.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
      this.errorBlocks = [];
    }
  }
}



private updateRecipe() {
  // Validate Fields
  this.validateFormFields();
  // Add to DB
  if (this.formValid === true && !this.errorBlocks.length) {
    // Create slug
    this.$data.slug = slugify(this.$data.recipeContent.title, {
      replacement: '-',
      remove: /[$*_+~.()'"!\-:@]/g,
      lower: true,
    });
    recipesDB.collection('recipes').doc(this.$data.recipeContent.id).update({
      category: this.$data.recipeContent.category,
      title: this.$data.recipeContent.title,
      hero: this.$data.recipeHeroPath,
      heroFile: this.$data.recipeHero,
      description: this.$data.recipeContent.description,
      ingredients: this.$data.ingredients,
      steps: this.$data.recipeSteps,
      slug: this.$data.slug,
    }).then(() => {
      this.$emit('closeBottom');
      this.$emit('refreshRecipes');
    }).catch((err) => {
      this.$data.recipeConfirmation = `Unable to Add Recipe ${err}`;
    });
  } else {
    this.scrollToError();
  }
}



  private created() {
    const recipeData = recipesDB.collection('recipes').where('title', '==', this.activeRecipe);
    recipeData.get().then((snapshot) => {
      snapshot.forEach((doc) => {
        this.$data.recipeContent = doc.data();
        this.$data.recipeContent.id = doc.id;
        this.$data.recipeHeroPath = doc.data().hero;
        this.$data.recipeHero = doc.data().heroFile;
        this.$data.recipeContent.ingredients.forEach((ingredient: object) => {
          this.$data.ingredients.push(ingredient);
        });
        this.$data.recipeContent.steps.forEach((step: string) => {
          this.$data.recipeSteps.push(step);
        });
      });
    });
    categories.collection('recipeCategories').get()
    .then((snapshot) => {
      snapshot.forEach((doc) => {
        const category = doc.data();
        const id = doc.id;
        this.categories.push(category);
      });
    });
  }
}
